document.addEventListener('DOMContentLoaded', () => {
  const QUESTIONS = window.QuizData.questions;
  const RECOMMENDATIONS = window.QuizData.recommendations;

  // --- STATE VARIABLES ---
  let step = 0;
  let answers = {};
  let userData = { name: '', email: '' };
  let isCodeUnlocked = false;
  let hasCopied = false;
  let hasSubmittedData = false;

  // NEW: Session ID identifies this specific user so Google Sheets updates the same row instead of creating new ones
  const sessionId = 'sn_' + Math.random().toString(36).substr(2, 9) + Date.now().toString(36);

  const container = document.getElementById('quiz-dynamic-content');
  const backBtn = document.getElementById('quiz-back-btn');

  // --- CORE FUNCTIONS ---

  function render() {
    // Show back button only on questions (Steps 1-4)
    backBtn.classList.toggle('hidden', step === 0 || step > 4);
    
    if (step === 0) renderIntro();
    else if (step >= 1 && step <= 4) renderQuestion();
    else if (step === 5) renderEmailGate();
    else if (step === 6) {
      // Final submission trigger to ensure recommendation is logged
      submitToGoogleSheets(); 
      renderResults();
    }

    if (window.lucide) lucide.createIcons();
  }

  function nextStep() { 
    step++; 
    render(); 
    // Trigger submission every time the user moves forward
    if (step > 0) {
      submitToGoogleSheets();
    }
  }

  backBtn.addEventListener('click', () => { 
    step--; 
    render(); 
  });

  // --- RENDER STEPS ---

  function renderIntro() {
    container.innerHTML = `
      <div class="max-w-xl mx-auto text-center py-8 w-full">
        <h1 class="text-3xl md:text-4xl font-bold text-stone-900 mb-3 leading-tight">Find your perfect <br /> mushroom routine.</h1>
        <p class="text-base text-stone-600 mb-6 px-4">Confused by functional mushrooms? Tell us how you're feeling, and we'll build a custom protocol for you in under 45 seconds.</p>
        <button id="start-btn" class="px-8 py-3 bg-[#2d749a] text-white rounded-full font-bold text-base hover:bg-[#205572] shadow-lg hover:shadow-xl transition-all">Take the Quiz</button>
      </div>
    `;
    document.getElementById('start-btn').addEventListener('click', nextStep);
  }

  function renderQuestion() {
    const qIndex = step - 1;
    const q = QUESTIONS[qIndex];
    const progress = (step / 6) * 100;

    let optionsHtml = q.options.map(opt => {
      const isSelected = q.type === "multi-select" ? (answers[q.id] || []).includes(opt.id) : answers[q.id] === opt.id;
      const borderClass = isSelected ? "border-[#2d749a] bg-[#f0f6f9]" : "border-stone-200 hover:border-[#7ab0cc] bg-white";
      const iconClass = isSelected ? "bg-[#d5e8f2] text-[#205572]" : "bg-stone-100 text-stone-600";
      const textClass = isSelected ? "text-[#1a445a]" : "text-stone-700";

      return `
        <div data-id="${opt.id}" class="quiz-option p-3 rounded-xl border-2 cursor-pointer transition-all flex items-center justify-between group ${borderClass}">
          <div class="flex items-center gap-3">
            ${opt.icon ? `<div class="p-1.5 rounded-full ${iconClass}"><i data-lucide="${opt.icon}" class="w-4 h-4"></i></div>` : ''}
            <span class="text-sm md:text-base font-medium ${textClass}">${opt.label}</span>
          </div>
          ${isSelected ? `<i data-lucide="check" class="text-[#2d749a] w-4 h-4"></i>` : ''}
        </div>
      `;
    }).join('');

    const btnDisabled = !answers[q.id] || answers[q.id].length === 0;
    const btnClass = btnDisabled ? "bg-stone-300 text-stone-500 cursor-not-allowed" : "bg-[#2d749a] text-white hover:bg-[#205572] shadow-md";

    container.innerHTML = `
      <div class="w-full bg-stone-200 h-1 rounded-full mb-5">
        <div class="bg-[#2d749a] h-1 rounded-full transition-all duration-500 ease-out" style="width: ${progress}%"></div>
      </div>
      <div class="max-w-lg mx-auto animate-fadeIn w-full">
        <h2 class="text-xl md:text-2xl font-bold text-stone-800 mb-1.5">${q.question}</h2>
        ${q.subhead ? `<p class="text-xs text-stone-500 mb-4">${q.subhead}</p>` : ''}
        <div class="space-y-2.5">${optionsHtml}</div>
        ${q.type === 'multi-select' ? `<button id="continue-btn" class="mt-5 w-full py-3 rounded-full font-bold text-base transition-colors ${btnClass}" ${btnDisabled ? 'disabled' : ''}>Continue</button>` : ''}
      </div>
    `;

    document.querySelectorAll('.quiz-option').forEach(el => {
      el.addEventListener('click', () => {
        const optId = el.getAttribute('data-id');
        if (q.type === 'multi-select') {
          let current = answers[q.id] || [];
          answers[q.id] = current.includes(optId) ? current.filter(id => id !== optId) : [...current, optId];
          render();
        } else {
          answers[q.id] = optId;
          render();
          setTimeout(nextStep, 250);
        }
      });
    });

    if (q.type === 'multi-select') document.getElementById('continue-btn').addEventListener('click', nextStep);
  }

  function renderEmailGate() {
    if (isCodeUnlocked) {
      container.innerHTML = `
        <div class="max-w-sm mx-auto text-center py-6 w-full">
          <div class="bg-[#e6f1f6] w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-3"><i data-lucide="check" class="text-[#2d749a] w-5 h-5"></i></div>
          <h2 class="text-xl font-bold text-stone-800 mb-1.5">Code Unlocked!</h2>
          <p class="text-stone-600 mb-5 text-sm">Copy your code below and apply it at checkout.</p>
          <div class="bg-stone-100 border-2 border-dashed border-stone-300 p-2.5 rounded-lg flex items-center justify-between mb-5 relative">
            <span class="font-mono text-base font-bold text-stone-800 tracking-wider">WELCOME10</span>
            <button id="copy-btn" class="text-xs font-bold text-[#2d749a] hover:text-[#205572] flex items-center gap-1 bg-[#f0f6f9] px-2.5 py-1 rounded-md transition-colors">
              ${hasCopied ? '<i data-lucide="check" class="w-3 h-3"></i> Copied' : '<i data-lucide="copy" class="w-3 h-3"></i> Copy'}
            </button>
          </div>
          <button id="show-routine-btn" class="w-full py-3 bg-[#2d749a] text-white rounded-full font-bold text-base hover:bg-[#205572] shadow-md transition-transform hover:scale-[1.02] flex items-center justify-center gap-2">Show My Routine <i data-lucide="arrow-right" class="w-4 h-4"></i></button>
        </div>
      `;
      document.getElementById('copy-btn').addEventListener('click', () => { 
        navigator.clipboard.writeText('WELCOME10').then(() => { 
          hasCopied = true; render(); 
          setTimeout(() => { hasCopied = false; render(); }, 2000); 
        }); 
      });
      document.getElementById('show-routine-btn').addEventListener('click', nextStep);
    } else {
      container.innerHTML = `
        <div class="max-w-sm mx-auto text-center py-6 w-full">
          <div class="bg-orange-100 w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-3"><i data-lucide="star" class="text-orange-600 fill-orange-600 w-5 h-5"></i></div>
          <h2 class="text-xl font-bold text-stone-800 mb-1.5">We've found your perfect match!</h2>
          <p class="text-stone-600 text-sm mb-5">Unlock your personalized routine and get <span class="font-bold text-orange-600">10% OFF</span> your first bundle.</p>
          <div class="space-y-2.5 text-left">
            <div><label class="text-[10px] font-bold text-stone-500 uppercase tracking-wider ml-1 mb-1 block">First Name</label><input type="text" id="quiz-name" placeholder="Your name" value="${userData.name}" class="w-full p-2.5 border border-stone-300 rounded-lg focus:ring-2 focus:ring-[#2d749a] outline-none text-sm" /></div>
            <div class="relative">
              <label class="text-[10px] font-bold text-stone-500 uppercase tracking-wider ml-1 mb-1 block">Email Address</label>
              <input type="email" id="quiz-email" placeholder="name@example.com" value="${userData.email}" class="w-full p-2.5 border border-stone-300 rounded-lg focus:ring-2 focus:ring-[#2d749a] outline-none text-sm" />
              <div id="email-valid-indicator" class="hidden absolute right-3 top-[34px] text-green-600"><i data-lucide="check-circle" class="w-4 h-4"></i></div>
            </div>
            <button id="unlock-btn" class="w-full py-3 rounded-full font-bold text-base shadow-md transition-transform hover:scale-[1.02] mt-2 bg-stone-300 text-stone-500 cursor-not-allowed" disabled>Unlock My 10% Off</button>
            <div class="text-center pt-1.5"><button id="skip-btn" class="text-stone-400 text-xs hover:text-stone-600 underline">No thanks, just show me my results</button></div>
          </div>
        </div>
      `;

      const updateInputs = () => {
        userData.name = document.getElementById('quiz-name').value;
        userData.email = document.getElementById('quiz-email').value;
        const btn = document.getElementById('unlock-btn');
        const indicator = document.getElementById('email-valid-indicator');
        
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const isEmailValid = emailRegex.test(userData.email);
        const isNameValid = userData.name.trim().length > 0;

        if (isEmailValid) indicator.classList.remove('hidden'); else indicator.classList.add('hidden');

        if (isEmailValid && isNameValid) { 
          btn.classList.remove('bg-stone-300', 'text-stone-500', 'cursor-not-allowed'); 
          btn.classList.add('bg-orange-600', 'text-white', 'hover:bg-orange-700'); 
          btn.disabled = false;
        } else { 
          btn.classList.add('bg-stone-300', 'text-stone-500', 'cursor-not-allowed'); 
          btn.classList.remove('bg-orange-600', 'text-white', 'hover:bg-orange-700'); 
          btn.disabled = true;
        }
        if (window.lucide) lucide.createIcons();
      };

      document.getElementById('quiz-name').addEventListener('input', updateInputs);
      document.getElementById('quiz-email').addEventListener('input', updateInputs);
      document.getElementById('unlock-btn').addEventListener('click', () => { 
        if (userData.name && userData.email) { 
          isCodeUnlocked = true; 
          render(); 
          submitToGoogleSheets(); // Update lead with real name/email
        }
      });
      document.getElementById('skip-btn').addEventListener('click', nextStep);
      updateInputs();
    }
  }

  // --- DATA SUBMISSION ---

  async function submitToGoogleSheets() {
    // Note: 'hasSubmittedData' check is removed so updates can occur multiple times
    
    let locationString = "Location Pending";
    try {
      const locResponse = await fetch('https://freeipapi.com/api/json');
      const locData = await locResponse.json();
      locationString = (locData && locData.cityName) ? `${locData.cityName}, ${locData.countryName}` : "Location Unknown";
    } catch (e) { locationString = "Location Blocked"; }

    // Safety Checks: Use optional chaining (?.) and default values to prevent "not loading" errors
    const q1Labels = (answers["q1"] || []).map(id => QUESTIONS[0].options.find(o => o.id === id)?.label).filter(Boolean).join(", ") || "None selected";
    const q2Label = QUESTIONS[1]?.options.find(o => o.id === answers["q2"])?.label || "Pending";
    const q3Label = QUESTIONS[2]?.options.find(o => o.id === answers["q3"])?.label || "Pending";
    const q4Label = QUESTIONS[3]?.options.find(o => o.id === answers["q4"])?.label || "Pending";
    
    let scenarioKey = (answers["q1"] || []).length === 1 ? answers["q1"][0] : "transformation";
    const recommendedRoutineTitle = RECOMMENDATIONS[scenarioKey]?.title || "Calculating...";

    const payload = {
      sessionId: sessionId,
      name: userData.name || "Anonymous",
      email: userData.email || "Anonymous",
      goals: q1Labels,
      format: q3Label,
      age: q4Label,
      routine: recommendedRoutineTitle,
      location: locationString
    };

    // YOUR GOOGLE SCRIPT URL
    const googleAppScriptURL = 'https://script.google.com/macros/s/AKfycbwyOQqki7IE19zJCYVooOYvsFcG8MG17WGmgeRTog__8LieB2fEJRhSjYSnf-yjHkkPhg/exec';

    try {
      await fetch(googleAppScriptURL, {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain;charset=utf-8' },
        body: JSON.stringify(payload)
      });
      console.log("Sync success for ID: " + sessionId);
    } catch (error) {
      console.error("Submission error:", error);
    }
  }

  // --- RESULTS PAGE ---

  function renderResults() {
    const goals = answers["q1"] || [];
    const format = answers["q3"] || "capsules";
    let scenarioKey = goals.length === 1 ? goals[0] : "transformation";
    const rec = RECOMMENDATIONS[scenarioKey];
    let bundleSelectorHtml = "";
// Only show the dropdown if there is more than one option available
if (rec.bundleOptions && rec.bundleOptions.length > 1) {
  bundleSelectorHtml = `
    <div class="mb-4 text-left">
      <label class="text-[10px] font-bold text-stone-400 uppercase tracking-widest mb-1 block italic">Select Format:</label>
      <select id="bundle-variant-selector" class="w-full p-2.5 bg-white border border-orange-200 rounded-xl text-sm font-bold outline-none cursor-pointer appearance-none shadow-sm">
        ${rec.bundleOptions.map((opt, i) => `<option value="${i}">${opt.label}</option>`).join('')}
      </select>
    </div>`;
}
    
    const productName = format === "powder" ? rec.powderProduct : rec.capsuleProduct;
    const productImage = format === "powder" ? rec.powderImage : rec.capsuleImage;
    const productId = format === "powder" ? rec.powderId : rec.capsuleId;
    const productPrice = format === "powder" ? rec.powderPrice : rec.capsulePrice;

    const cleanProductName = productName ? productName.split('|')[0].replace(/(Capsules|Powder)/gi, "").trim() : "Mushroom Product";
    
    const singleImgHtml = productImage 
      ? `<img src="${productImage}" alt="${productName}" class="w-full h-36 object-cover object-center bg-stone-50" />` 
      : `<div class="h-36 ${rec.imageColor} flex items-center justify-center"><span class="text-stone-500 font-medium tracking-widest opacity-50 text-[10px]">NO IMAGE</span></div>`;
      
    const bundleImgHtml = rec.bundleImage 
      ? `<img src="${rec.bundleImage}" alt="${rec.bundleTitle}" class="w-full h-44 object-cover object-center bg-stone-50" />` 
      : `<div class="h-44 ${rec.imageColor} flex items-center justify-center opacity-90"><span class="text-stone-600 font-medium tracking-widest opacity-50 text-[10px]">NO IMAGE</span></div>`;

    let bundlePriceHtml = `<div class="flex items-end gap-1.5 mb-2.5"><span id="bundle-price-display" class="text-xl font-bold text-stone-900">${rec.bundlePrice || ''}</span>`;
    if (rec.bundleComparePrice && rec.bundleSavings > 0) {
      bundlePriceHtml += `<span class="text-sm text-stone-400 line-through mb-0.5">${rec.bundleComparePrice}</span><span class="text-orange-600 font-bold text-[11px] mb-1 ml-auto">Save ${rec.bundleSavings}%</span>`;
    }
    bundlePriceHtml += `</div>`;

    const goalLabelsHtml = goals.map(gId => {
      const option = QUESTIONS[0].options.find(opt => opt.id === gId);
      return option ? `<span class="bg-white border border-stone-200 text-stone-700 px-2.5 py-0.5 rounded-lg text-[11px] font-semibold shadow-sm">${option.tags.join(" & ")}</span>` : "";
    }).join('');

    const formatLabel = format === "powder" ? "Powders" : "Capsules";
    let routineStepsHtml = "";
    
    if (rec.routineType === "AM" || rec.routineType === "AMPM") {
      routineStepsHtml += `<div class="flex items-start gap-2.5 bg-white p-3.5 rounded-xl border border-stone-200 shadow-sm transition-all hover:shadow-md"><div class="bg-orange-50 text-orange-500 p-2 rounded-lg flex-shrink-0"><i data-lucide="sun" class="w-4 h-4"></i></div><div><div class="font-bold text-stone-900 text-xs uppercase tracking-wider mb-0.5">Morning</div><div class="text-stone-600 text-sm font-medium leading-normal">Take ${format === "capsules" ? "2 capsules" : "1 tsp"} of <strong class="text-stone-900">${cleanProductName}</strong> with water or coffee.</div></div></div>`;
    }
    if (rec.routineType === "PM" || rec.routineType === "AMPM") {
      const pmText = rec.routineType === "AMPM" ? `Take 2 capsules of <strong class="text-stone-900">Reishi</strong> to unwind before bed.` : `Take ${format === "capsules" ? "2 capsules" : "1 tsp"} of <strong class="text-stone-900">${cleanProductName}</strong> 1 hour before bed.`;
      routineStepsHtml += `<div class="flex items-start gap-2.5 bg-white p-3.5 rounded-xl border border-stone-200 shadow-sm transition-all hover:shadow-md"><div class="bg-indigo-50 text-indigo-500 p-2 rounded-lg flex-shrink-0"><i data-lucide="moon" class="w-4 h-4"></i></div><div><div class="font-bold text-stone-900 text-xs uppercase tracking-wider mb-0.5">Evening</div><div class="text-stone-600 text-sm font-medium leading-normal">${pmText}</div></div></div>`;
    }

    const bundleItemsHtml = rec.bundleItems.map(item => `<li class="flex items-center gap-2 text-stone-700 font-medium text-sm"><div class="w-1.5 h-1.5 rounded-full bg-orange-500"></div>${item}</li>`).join('');

    container.innerHTML = `
      <div class="max-w-6xl mx-auto w-full">
        <div class="text-center mb-5">
          <span class="bg-[#e6f1f6] text-[#205572] px-2.5 py-1 rounded-full text-[10px] font-bold tracking-wide uppercase">Recommended For You</span>
          <h1 class="text-2xl md:text-3xl font-bold text-stone-900 mt-3 mb-1.5">${rec.title}</h1>
          <p class="text-base text-stone-600 max-w-xl mx-auto">${rec.pitch}</p>
        </div>
        <div class="bg-white rounded-2xl shadow-sm border border-stone-200 p-4 md:p-6 mb-5 w-full">
          <div class="flex flex-col md:flex-row gap-5 items-stretch w-full">
            <div class="w-full md:w-[55%] flex flex-col justify-center">
              <h3 class="text-base font-bold text-stone-800 mb-2.5 flex items-center gap-1.5"><div class="w-1.5 h-1.5 rounded-full bg-orange-500"></div>Your Quiz Profile</h3>
              <div class="flex flex-wrap gap-1.5 mb-3">${goalLabelsHtml} <span class="bg-white border border-stone-200 text-stone-700 px-2.5 py-0.5 rounded-lg text-[11px] font-semibold shadow-sm">Prefers ${formatLabel}</span></div>
              <h3 class="text-sm font-bold text-stone-800 mb-1.5 mt-2">Why This Routine Works:</h3>
              <p class="text-stone-600 leading-normal text-sm">${rec.solutionStatement}</p>
            </div>
            <div class="w-full md:w-[45%] bg-[#faf9f8] rounded-xl p-4 md:p-5 border border-stone-200 flex flex-col">
              <div class="text-[10px] font-bold text-stone-400 uppercase tracking-widest mb-3 pb-2.5 border-b border-stone-200 flex items-center gap-1.5"><i data-lucide="clock" class="w-3 h-3 text-stone-400"></i> Your Daily Routine</div>
              <div class="space-y-2.5 flex-1 flex flex-col justify-center">${routineStepsHtml}</div>
            </div>
          </div>
        </div>
        <div class="flex flex-col md:flex-row gap-5 items-stretch w-full">
          <div class="w-full md:w-1/2 bg-white rounded-2xl shadow-sm border border-stone-200 overflow-hidden flex flex-col">
            ${singleImgHtml}
            <div class="p-5 flex-1 flex flex-col">
              <div class="mb-3"><h3 class="text-lg font-bold text-stone-800 mb-0.5">The Starter</h3><p class="text-[#2d749a] font-medium text-base">${productName}</p></div>
              <ul class="space-y-2 mb-5 flex-1"><li class="flex items-start gap-2 text-stone-600 text-sm"><i data-lucide="check" class="text-[#2d749a] mt-0.5 flex-shrink-0 w-4 h-4"></i><span>Based on your preference for <strong>${formatLabel}</strong></span></li><li class="flex items-start gap-2 text-stone-600 text-sm"><i data-lucide="check" class="text-[#2d749a] mt-0.5 flex-shrink-0 w-4 h-4"></i><span>30-Day Supply</span></li></ul>
              <button onclick="window.addItemsToCart([{ id: ${productId}, quantity: 1 }])" class="w-full py-2.5 border-2 border-stone-900 text-stone-900 rounded-xl text-sm font-bold hover:bg-stone-50 transition-colors">Shop Single ${productPrice ? `(${productPrice})` : ''}</button>
            </div>
          </div>
    
          <div class="w-full md:w-1/2 bg-white rounded-2xl shadow-xl border-2 border-orange-500 overflow-hidden flex flex-col relative md:-translate-y-2">
            <div class="absolute top-0 right-0 bg-orange-500 text-white px-3 py-1 rounded-bl-xl font-bold text-[10px] tracking-wider z-10">BEST VALUE</div>
            ${bundleImgHtml}
            <div class="p-5 flex-1 flex flex-col bg-orange-50/40">
              <div class="mb-3"><h3 class="text-lg font-bold text-stone-800 mb-0.5">${rec.bundleTitle}</h3><p class="text-stone-600 text-xs">${rec.bundlePitch}</p></div>
              ${bundleSelectorHtml}
              <div class="bg-white p-3 rounded-xl border border-orange-100 mb-5 shadow-sm"><p class="text-[9px] text-stone-400 uppercase tracking-wide font-bold mb-1.5">What's Inside:</p><ul class="space-y-1.5">${bundleItemsHtml}</ul></div>
              <div class="mt-auto flex flex-col items-start"><a href="#" class="inline-flex items-center gap-1 text-xs font-bold text-orange-600 hover:text-orange-700 mb-2.5 group transition-colors">Learn more <i data-lucide="arrow-right" class="w-3.5 h-3.5 group-hover:translate-x-1 transition-transform"></i></a> ${bundlePriceHtml} <button  id="bundle-add-to-cart-btn" onclick="window.addItemsToCart([{ id: ${rec.bundleId}, quantity: 1 }])" class="w-full py-2.5 bg-orange-600 text-white rounded-xl text-sm font-bold hover:bg-orange-700 shadow-md flex items-center justify-center gap-1.5 transition-colors">Add Bundle to Cart <i data-lucide="arrow-right" class="w-3.5 h-3.5"></i></button></div>
            </div>
          </div>
        </div>
        <div class="mt-6 text-center w-full">
          <button onclick="window.startOverQuiz()" class="text-stone-500 hover:text-[#2d749a] font-bold text-sm flex items-center justify-center gap-1.5 mx-auto transition-colors"><i data-lucide="rotate-ccw" class="w-3.5 h-3.5"></i> Start Over</button>
        </div>
      </div>     `;

      // --- PASTE AT THE BOTTOM OF THE FUNCTION ---
const bundleSelector = document.getElementById('bundle-variant-selector');
if (bundleSelector) {
  bundleSelector.addEventListener('change', (e) => {
    // Look up the choice in the bundleOptions array we sent from Liquid
    const choice = rec.bundleOptions[e.target.value];
    
    // Swap the price text
    const priceDisplay = document.getElementById('bundle-price-display');
    if (priceDisplay) priceDisplay.innerText = choice.price;
    
    // Swap the product ID in the button so the correct item is added to cart
    const cartBtn = document.getElementById('bundle-add-to-cart-btn');
    if (cartBtn) {
      cartBtn.setAttribute('onclick', `window.addItemsToCart([{ id: ${choice.id}, quantity: 1 }])`);
    }
  });
}
  }

  // --- GLOBAL HELPERS ---

  window.startOverQuiz = function() {
    step = 0;
    answers = {};
    hasSubmittedData = false; 
    render();
    const wrapper = document.getElementById('MushroomQuizWrapper');
    if (wrapper) { window.scrollTo({ top: wrapper.offsetTop - 50, behavior: 'smooth' }); }
  };

  window.addItemsToCart = function(itemsArray) {
    if (!itemsArray[0].id) { alert("Please map this product in your Theme Customizer first."); return; }
    event.target.innerHTML = 'Adding...';
    event.target.style.opacity = '0.7';
    event.target.style.pointerEvents = 'none';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: itemsArray })
    })
    .then(response => { if (!response.ok) throw new Error('Network error'); return response.json(); })
    .then(() => { window.location.href = '/checkout'; })
    .catch(error => {
      console.error('Error:', error);
      alert('There was an error. Please try again.');
      event.target.innerHTML = 'Try Again';
      event.target.style.opacity = '1';
      event.target.style.pointerEvents = 'auto';
    });
  };

  // Start the engine
  render();
});